import Vue from 'vue'
let Enhancer = {
    get: function (target, key, receiver) {
        if (target._model && key in target._model) {
            return target[key] ? target[key] : Reflect.get(target._model, key, receiver)
        }
        return Reflect.get(target, key, receiver)
    },
    set(target, key, value) {
        if (key in target) {
            Vue.set(target, key, value)
            return true
        }
        Vue.set(target._model, key, value)
        return true
    },
}

export default Enhancer
